import { Button, Icon, IconName } from '@design-system';
import { FC } from 'react';

import { useFlow } from '../../../providers';

interface DialogIntroProps {
  buttonText: string;
  content: {
    description: string;
    icon: IconName;
    title: string;
  }[];
}

export const DialogIntro: FC<DialogIntroProps> = ({ buttonText, content }) => {
  const { goNextStep } = useFlow();

  return (
    <div className="flex flex-col space-y-6">
      {content.map((item) => (
        <div className="flex space-x-3">
          <div className="shrink-0">
            <Icon name={item.icon} />
          </div>
          <div>
            <p>{item.title}</p>
            <p className="text-neutral-4">{item.description}</p>
          </div>
        </div>
      ))}
      <Button
        fullWidth
        label={buttonText}
        onClick={goNextStep}
        variant="primary"
      />
    </div>
  );
};
